import ActiveAccountsTable from './components/ActiveAccountsTable';
import UseAccountStore from '../../../stores/DataStore';
import React, {useEffect} from 'react';
import Widget from '../../../components/widget/Widget';
import {HiOutlineCash} from 'react-icons/hi';
import UseActiveAccountStore from '../../../stores/AccountStore';
import {formatCurrency} from '../../../stores/JSHelper';
import {FiSearch} from 'react-icons/fi';
import Card from '../../../components/card';

const ActiveAccounts = () => {
  const {refresh, activeAccounts} = UseActiveAccountStore();
  const [searchQuery, setSearchQuery] = React.useState('');
  const {account} = UseAccountStore();

  useEffect(() => {
    (async () => {
      await refresh(searchQuery);
    })();
  }, [account]);

  const widgets = [];

  return (
    <div>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-6">
        {widgets.map((d) => {
          return <Widget icon={<HiOutlineCash className="h-7 w-7" />} title={d.title} subtitle={d.subtitle} />;
        })}
      </div>

      <div className="my-5">
        <div>
          <Card extra={'w-full h-full sm:overflow-auto'}>
            <header className="relative flex items-center justify-between px-6 pt-4">
              <div className="text-xl font-bold text-navy-700 dark:text-white">
                Active Accounts <p className="text-sm">(Balance &gt; {formatCurrency(0, 'INR')})</p>
              </div>
              <div className="relative mt-[3px] flex h-[61px] w-[555px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[565px] md:flex-grow-0 md:gap-1 xl:w-[565px] xl:gap-2">
                <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[525px]">
                  <p className="pl-3 pr-2 text-xl">
                    <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
                  </p>
                  <input
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      refresh(e.target.value);
                    }}
                    type="text"
                    placeholder="Search..."
                    className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
                  />
                </div>
              </div>
            </header>
            <ActiveAccountsTable activeAccounts={activeAccounts} onRefundTriggered={() => refresh(searchQuery)} />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ActiveAccounts;
